import { BACKEND_ROUTES } from "../../backendRoutes";
import { FetchErrorAlert } from "../../components/FetchErrorAlert";
import { PipelineInstance } from "./PipelineInstance";
import { Skeleton } from "@mui/material";
import { TRAIT_GROUP_ASSOCIABLE_TYPES } from "../../constants";
import { useParams } from "react-router-dom";
import useSWRImmutable from "swr/immutable";

export function PipelineInstanceLayout() {
    const { pipelineInstanceUuid } = useParams();

    const {
        data: pipelineInstance,
        error: pipelineInstanceFetchError,
        isLoading: pipelineInstanceIsLoading,
        mutate,
    } = useSWRImmutable(
        `${BACKEND_ROUTES.PIPELINE_INSTANCE}/${pipelineInstanceUuid}?associatedTraitGroups=true`
    );

    // ----- Fetch all the module versions referenced by the jobs -----
    /*const jobs = pipelineInstance?.translatedPipeline?.spec?.jobs || [];
    const moduleVersionUuids = [
        ...new Set(jobs.map((j) => j.mainModuleVersionUuid).filter(Boolean)),
    ];*/
    // TODO: Fetch only module versions whose UUID is in moduleVersionUuids
    // either by adding a custom multi-URL fetcher for useSWR or by adding an array
    // query param in the BE
    const {
        data: moduleVersionsData,
        error: moduleVersionsFetchError,
        isLoading: moduleVersionsIsLoading,
    } = useSWRImmutable(`${BACKEND_ROUTES.MODULE_VERSION}?limit=200`);

    // ----- Get the cropUuid if there is at least one ATG of associableType equal
    // to ExperimentMission -----
    const firstExperimentMissionUuid =
        pipelineInstance?.AssociatedTraitGroups?.find(
            (atg) =>
                atg.associableType ===
                TRAIT_GROUP_ASSOCIABLE_TYPES.EXPERIMENT_MISSION
        )?.associableUuid;
    const {
        data: experimentMission,
        error: experimentMissionFetchError,
        isLoading: experimentMissionIsLoading,
    } = useSWRImmutable(
        firstExperimentMissionUuid
            ? `${BACKEND_ROUTES.EXPERIMENT_MISSION}/${firstExperimentMissionUuid}?parentInfo=true`
            : null
    );
    // Use the crop of the experiment (via the eager-loaded `Experiment`),
    // not the pipeline template's crop, to drive both the crop presets and
    // the trained-model selector grouping.
    const cropUuid = experimentMission?.Experiment.cropUuid;

    // ----- If there is cropUuid, fetch the crop module presets -----
    const {
        data: presetsData,
        error: presetsFetchError,
        isLoading: presetsIsLoading,
    } = useSWRImmutable(
        cropUuid
            ? `${BACKEND_ROUTES.CROP_MODULE_PRESET}?cropUuid=${cropUuid}`
            : null
    );

    const mergedFetchError =
        pipelineInstanceFetchError ??
        moduleVersionsFetchError ??
        experimentMissionFetchError ??
        presetsFetchError;
    if (mergedFetchError) return <FetchErrorAlert error={mergedFetchError} />;

    const isLoading =
        pipelineInstanceIsLoading ||
        moduleVersionsIsLoading ||
        experimentMissionIsLoading ||
        presetsIsLoading;
    if (isLoading)
        return (
            <Skeleton
                animation="wave"
                variant="rectangular"
                width="100%"
                height="75dvh"
            />
        );

    return (
        <PipelineInstance
            pipelineInstance={pipelineInstance}
            moduleVersions={moduleVersionsData.rows}
            presets={presetsData?.rows}
            experimentCropUuid={cropUuid}
            mutate={mutate}
        />
    );
}
